import { z } from "zod";

export const requireCorrectionSchema = z.object({
  note: z
    .string()
    .min(1, "Uzasadnienie jest wymagane.")
    .max(4000, "Uzasadnienie jest za długie, maksymalnie 4000 znaków"),
});
